import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useHistory, Link } from 'react-router-dom';
import { useMountedState } from 'react-use';

import DashboardRoutes from '../Dashboard/routes';

import { validateData } from '../../utils/joi';

import { IAppReduxState } from '../../redux/reducer';

import ProductLogo from '../../components/Common/ProductLogo';
import { TextInputComp, ButtonComp } from '../../components/Forms';

import * as constants from './constants';
import * as services from './services';
import AuthRoutes from './routes';

const DefaultFormError = {
  email: undefined,
};

function PasswordForgot() {
  const isMounted = useMountedState();
  const history: any = useHistory();
  const { auth } = useSelector((state: IAppReduxState) => state.auth);

  const [email, setEmail] = useState(history.location?.state?.email || '');
  const [isFetching, setIsFetching] = useState(false);
  const [errors, setErrors] = useState(DefaultFormError);

  if (auth.token) {
    history.push(DashboardRoutes.routes.home.path);
  }

  useEffect(() => {
    document.body.className = 'p-0 m-0';
    return () => {
      document.body.className = '';
    };
  });

  const formSubmitted = async (event: React.ChangeEvent<any>) => {
    event.preventDefault();

    const validate = validateData({ email }, constants.PasswordForgotJoiScheme);

    if (validate.errors) {
      setErrors(validate.errors);
      return;
    }

    setIsFetching(true);
    setErrors(DefaultFormError);

    try {
      const result = await services.passwordForgotService({ email });

      history.push(AuthRoutes.login.path, { successMsg: result.message });

      //Todo remove after password setup
    } catch (error) {
      console.error(error);
    }

    if (!isMounted()) {
      return;
    }

    setIsFetching(false);
  };

  return (
    <div id="wrapper">
      <div className="session-wrap login-wrap d-flex align-items-center justify-content-center justify-content-lg-end">
        <div className="session-content contact-form-wrap text-center card shadow-box">
          <ProductLogo />

          <div>
            <form onSubmit={formSubmitted}>
              <div className="form-group text-left mb-4">
                <TextInputComp
                  name="email"
                  onChange={setEmail}
                  label="Email"
                  autoFocus
                  placeholder="Email *"
                  value={email}
                  errorMsg={errors.email}
                />
              </div>

              <div className="form-group">
                <ButtonComp
                  loading={isFetching}
                  type="submit"
                  className="btn btn-one btn-block btn-primary"
                  text="Password Forgot"
                />
              </div>

              <div className="link-register">
                <span>
                  Already have an account?{' '}
                  <Link
                    to={{
                      pathname: AuthRoutes.login.path,
                      state: { email },
                    }}
                  >
                    Log In
                  </Link>
                </span>
              </div>

              <div className="link-register">
                <span>
                  Don’t have an account?{' '}
                  <Link
                    className="pull-left"
                    to={{
                      pathname: AuthRoutes.register.path,
                      state: { email },
                    }}
                  >
                    Register
                  </Link>
                </span>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
}

export default PasswordForgot;
